/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Continuewithgoogle2Inputs */

const zh_auth_continuewithgoogle2 = /** @type {(inputs: Auth_Continuewithgoogle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 Google 登录`)
};

const en_auth_continuewithgoogle2 = /** @type {(inputs: Auth_Continuewithgoogle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with Google`)
};

const es_auth_continuewithgoogle2 = /** @type {(inputs: Auth_Continuewithgoogle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar con Google`)
};

/**
* | output |
* | --- |
* | "Continue with Google" |
*
* @param {Auth_Continuewithgoogle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_continuewithgoogle2 = /** @type {((inputs?: Auth_Continuewithgoogle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Continuewithgoogle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_continuewithgoogle2(inputs)
	if (locale === "en") return en_auth_continuewithgoogle2(inputs)
	return es_auth_continuewithgoogle2(inputs)
});
export { auth_continuewithgoogle2 as "auth_continueWithGoogle" }